export const getActiveState = (states) => {
  const activeState = Object.entries(JSON.parse(states)).filter(
    (item) => item[1].active === 1,
  );
  if (activeState.length === 0) return null;
  return activeState[0][0];
};

export const isCorrectLink = (str) => {
  try {
    return !!new URL(str);
  } catch (_) {
    return false;
  }
};

export const parseJSON = (str, fallback = str) => {
  if (typeof str !== 'string') return fallback;

  try {
    return JSON.parse(str);
  } catch {
    return fallback;
  }
};
